import type { IErrorsProps } from "../../types";
import { HighlightOff, PermScanWifi } from "@mui/icons-material";
import { Button, Dialog, Typography, DialogTitle, DialogActions } from "@mui/material";

export default function Errors(props: IErrorsProps) {
  const { text, paneemError, disabled, isAuthentication, styles, handleResetAttempt } = props;

  return (
    <Dialog open={!!paneemError} PaperProps={{ sx: { ...styles.dialogBase, justifyContent: "center" } }}>
      <DialogTitle sx={styles.dialogTitle}>
        <Typography sx={styles.errorText}>
          {paneemError === 1 ? text.matchingError : text.somethingWentWrong}
        </Typography>

        {paneemError === 1 ? (
          <>
            <Typography sx={styles.dontGiveUpText}>{text.dont_give_up}</Typography>

            <Typography sx={styles.errorText}>{text.tryAgain}</Typography>

            <HighlightOff sx={styles.errorIcon} />
          </>
        ) : null}

        <Typography sx={styles.errorText}>
          {paneemError === 1 && !isAuthentication ? text.documentVisible : text.internetConnection}
        </Typography>
      </DialogTitle>

      {paneemError === 2 ? <PermScanWifi sx={styles.errorIcon} /> : null}

      <DialogActions sx={styles.dialogActions}>
        <Button onClick={handleResetAttempt} disabled={disabled} variant="contained" sx={styles.continue}>
          {text.tryAgainShort}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
